import React, { useState } from 'react'
import { ClipLoader } from 'react-spinners'

import { Button } from '@missionlabs/smartagent-app-components'

import { EmailMessage } from 'components'
import { IEmailMessage } from 'components/EmailMessage/types'

import './email-messages.scss'
import { useSelector } from 'react-redux'
import { selectTaskTranscriptPaginationSize } from 'store/app/app.selectors'


export interface Props {
    emailMessages?: IEmailMessage[]
    highlightedMessageId?: string
    viewPreviousEmailMessages?: boolean
    setViewPreviousEmailMessages: (...args: any[]) => void
}

const EmailMessages: React.FC<Props> = ({
    emailMessages,
    highlightedMessageId,
    viewPreviousEmailMessages = false,
    setViewPreviousEmailMessages,
}) => {
    const [currentPage, setCurrentPage] = useState(1);



    return (
        <>
            {!emailMessages ? (
                <div className="email-messages-loading">
                    <ClipLoader />
                </div>
            ) : (
                (() => {
                    const viewableMessages = viewPreviousEmailMessages
                        ? emailMessages
                        : emailMessages.filter(
                            (message) => message.messageId === highlightedMessageId,
                        )

                    const contactsPerPage = useSelector(selectTaskTranscriptPaginationSize)

                    const messagesPerPage = contactsPerPage ?? 25

                    const totalPages = Math.ceil(viewableMessages.length / messagesPerPage);

                    const paginatedMessages = viewableMessages.slice(
                        (currentPage - 1) * messagesPerPage,
                        currentPage * messagesPerPage,
                    );
                    const handleNextPage = () => {
                        if (currentPage < totalPages) {
                            setCurrentPage(currentPage + 1);
                        }
                    };

                    const handlePreviousPage = () => {
                        if (currentPage > 1) {
                            setCurrentPage(currentPage - 1);
                        }
                    };

                    return (
                        <section className="email-messages">
                            {paginatedMessages.map(
                                ({
                                    subject,
                                    to,
                                    from,
                                    externalFrom,
                                    forwardedTo,
                                    repliedTo,
                                    content,
                                    timestamp,
                                    type,
                                    cc,
                                    messageId,
                                    attachments,
                                }) => (
                                    <EmailMessage
                                        key={messageId}
                                        from={externalFrom || from}
                                        to={forwardedTo || repliedTo || to}
                                        subject={subject}
                                        content={content}
                                        timestamp={timestamp}
                                        type={type}
                                        cc={cc}
                                        highlight={
                                            highlightedMessageId === messageId &&
                                            viewPreviousEmailMessages
                                        }
                                        attachments={attachments}
                                    />
                                ),
                            )}
                            {!viewPreviousEmailMessages && emailMessages.length > 1 ? (
                                <Button
                                    className="view-previous-messages"
                                    styling="white"
                                    onClick={setViewPreviousEmailMessages}
                                >
                                    Show all emails
                                </Button>
                            ) : <div className="sa-pagination">
                                <div className="sa-pagination-relative">
                                    <button
                                        onClick={handlePreviousPage}
                                        disabled={currentPage === 1}
                                        aria-label="Previous page"
                                    >
                                        &lt;
                                    </button>
                                    <div>
                                        Page {currentPage} of {totalPages}
                                    </div>
                                    <button
                                        onClick={handleNextPage}
                                        disabled={currentPage === totalPages}
                                        aria-label="Next page"
                                    >
                                        &gt;
                                    </button>
                                </div>
                            </div>}
                        </section>
                    )
                })()
            )}
        </>
    )
}

export default EmailMessages
